/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface DashboardAiModelCount
 */
export interface DashboardAiModelCount {
  /**
   *
   * @type {number}
   * @memberof DashboardAiModelCount
   */
  liveModelCount: number;
  /**
   *
   * @type {number}
   * @memberof DashboardAiModelCount
   */
  inReviewModelCount: number;
  /**
   *
   * @type {number}
   * @memberof DashboardAiModelCount
   */
  notLiveModelCount: number;
}

/**
 * Check if a given object implements the DashboardAiModelCount interface.
 */
export function instanceOfDashboardAiModelCount(value: object): value is DashboardAiModelCount {
  if (!('liveModelCount' in value) || value['liveModelCount'] === undefined) return false;
  if (!('inReviewModelCount' in value) || value['inReviewModelCount'] === undefined) return false;
  if (!('notLiveModelCount' in value) || value['notLiveModelCount'] === undefined) return false;
  return true;
}

export function DashboardAiModelCountFromJSON(json: any): DashboardAiModelCount {
  return DashboardAiModelCountFromJSONTyped(json, false);
}

export function DashboardAiModelCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardAiModelCount {
  if (json == null) {
    return json;
  }
  return {
    liveModelCount: json['live_model_count'],
    inReviewModelCount: json['in_review_model_count'],
    notLiveModelCount: json['not_live_model_count'],
  };
}

export function DashboardAiModelCountToJSON(value?: DashboardAiModelCount | null): any {
  if (value == null) {
    return value;
  }
  return {
    live_model_count: value['liveModelCount'],
    in_review_model_count: value['inReviewModelCount'],
    not_live_model_count: value['notLiveModelCount'],
  };
}
